var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-button",
    {
      staticClass: "import-button",
      attrs: { type: "primary", icon: "el-icon-upload2" },
    },
    [
      _vm._v(" Import "),
      _c("input", {
        ref: "file",
        attrs: { type: "file", accept: _vm.accept },
        on: { change: _vm.onFileChange },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }